import { ArrayInput, SimpleFormIterator } from "ra-ui-materialui";
import {
  DebouncedTextInput,
  useDebounce,
  useFieldLabel,
} from "ra-friendsofbabba";
import React, { useEffect, useRef, useState } from "react";

import { get } from "lodash";
import { required } from "react-admin";

const AuthorsInput = (props) => {
  const fieldLabel = useFieldLabel({
    resource: "technical-report-scientific-production-authors",
  });
  const didMount = useRef(false);
  const [timestamp, setTimestamp] = useState(new Date().getTime());
  const value = get(props.record, props.source);
  const debouncedValue = useDebounce(value, 1000);
  useEffect(() => {
    if (!debouncedValue) {
      return;
    }
    if (didMount.current) {
      return;
    }
    // Perché?
    // Se non forzo il refresh tramite l'aggiornamento del timestamp (collegato
    // alla key del componente ArrayInput), aprendo l'app e seguendo il flow: lista -> visualizza,
    // l'elenco dei comuni partner non è stampato correttamente a causa di un 'undefined' che
    // viene poi trasformato in elenco.
    didMount.current = true;
    setTimestamp(new Date().getTime());
  }, [debouncedValue]);
  return (
    <ArrayInput {...props} label={false} key={timestamp}>
      <SimpleFormIterator>
        <DebouncedTextInput
          maxLength={100}
          source="first_name"
          label={fieldLabel("first_name")}
          validate={required()}
        />
        <DebouncedTextInput
          maxLength={100}
          source="last_name"
          label={fieldLabel("last_name")}
          validate={required()}
        />
      </SimpleFormIterator>
    </ArrayInput>
  );
};

export default AuthorsInput;
